import { useEffect, useState } from "react";
import successThumb from "../assets/cameracheck/thumbup.png";
type NetworkState = {
  label: string;
  color: string;
  icon?: string;
};

export const useNetworkQuality = (): NetworkState => {
  const [state, setState] = useState<NetworkState>({
    label: "Checking...",
    color: "#999",
  });

  useEffect(() => {
    const connection =
      (navigator as any).connection ||
      (navigator as any).mozConnection ||
      (navigator as any).webkitConnection;

    const updateQuality = () => {
      if (!navigator.onLine) {
        setState({
          label: "Offline",
          color: "#ff4d4f",
          icon: "❌",
        });
        return;
      }

      const type = connection?.effectiveType;

      switch (type) {
        case "4g":
          setState({
            label: "Stable",
            color: "#2f9668",
            icon: successThumb,
          });
          break;
        // case "3g":
        //   setState({
        //     label: "Moderate",
        //     color: "#faad14",
        //     icon: "🟡",
        //   });
        //  break;
        case "2g":
        case "slow-2g":
          setState({
            label: "Poor",
            color: "#ff4d4f",
            icon: "🔴",
          });
          break;
        default:
          setState({
            label: "Unknown",
            color: "#999",
            icon: "",
          });
      }
    };

    updateQuality();

    connection?.addEventListener("change", updateQuality);
    window.addEventListener("online", updateQuality);
    window.addEventListener("offline", updateQuality);

    return () => {
      connection?.removeEventListener("change", updateQuality);
      window.removeEventListener("online", updateQuality);
      window.removeEventListener("offline", updateQuality);
    };
  }, []);

  return state;
};
